import React, {Fragment} from 'react';
import createForm from "./Form";
import Select from "../../form/Select";
import TextInput from "../../form/TextInput";
import DateTimeInput from "../../form/DateTimeInput";
import Shipping from "../../form/shipping/shipping";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import SelectorDocuments from "../../form/SelectorGrid/SelectorDocuments";
import connect from "react-redux/es/connect/connect";
import {CurrencyFormatter, DateFormatter, PartnerSelect} from "../../../utils/formatters";
import CheckBox from "../../form/CheckBox";

class ShippingServiceForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            autoFill: !this.props.values[this.props.componentConfig.idfield]
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.values[prevProps.componentConfig.idfield] !== this.props.values[this.props.componentConfig.idfield]) {
            this.setState({
                autoFill: !this.props.values[this.props.componentConfig.idfield]
            })
        }
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-4">
                        <Select
                            label="Vevő"
                            name="customer"
                            component="partner"
                            optionsTemplate={PartnerSelect}
                            objectValue={true}
                            labelKey="name"
                            valueKey="partner_id"
                            storeType="remote"
                            value={this.props.values.partner}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-1">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values.shipping[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-md-2">
                        <Select
                            objectValue={true}
                            optionname="shippingstate"
                            storeType="local"
                            name="state"
                            value={ (this.props.values && this.props.values.state) || null }
                            label="Állapot"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("state")}
                            disabled={true}
                        />
                    </div>
                    <div className="col-md-2">
                        <TextInput
                            name="contact"
                            value={this.props.values.shipping.contact}
                            label="Név"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("contact")}
                            disabled={this.props.disabled}
                        />
                    </div>
                    <div className="col-md-2">
                        <TextInput
                            name="telnum"
                            value={this.props.values.shipping.telnum}
                            label="Telefonszám"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("telnum")}
                            disabled={this.props.disabled}
                        />
                    </div>
                    <div className="col-md-3">
                        <TextInput
                            name="email"
                            value={this.props.values.shipping.email}
                            label="Email"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("email")}
                            disabled={this.props.disabled}
                        />
                    </div>
                    <div className="col-md-2">
                        <TextInput
                            name="promised_shipping_date"
                            value={this.props.values.shipping.promised_shipping_date}
                            label="Ígért szállítási határidő"
                            saveChanges={this.props.setFieldValue}
                            formatter={DateFormatter}
                            {...this.props.getFieldProps("promised_shipping_date")}
                            disabled="disabled"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <Select
                            objectValue={false}
                            optionname="shippingprovider"
                            storeType="local"
                            name="serviceprovider_type"
                            value={(this.props.values && this.props.values.shipping.serviceprovider_type) || null}
                            label="Szállítás módja"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("serviceprovider_type")}
                            disabled={this.props.disabled}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-3">
                        <TextInput
                            name="tracking_id"
                            value={this.props.values.shipping.tracking_id}
                            label="Követési kód"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("tracking_id")}
                            disabled={this.props.disabled}
                        />
                    </div>
                    <div className="col-md-3 currency">
                        <TextInput
                            name="shipping_fee"
                            value={this.props.values.shipping.shipping_fee}
                            label="Szállítási díj"
                            formatter={CurrencyFormatter}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("shipping_fee")}
                            disabled={this.props.disabled}
                        />
                    </div>
                    <div className="col-md-3">
                        <DateTimeInput
                            {...this.props.getFieldProps("pickup_date")}
                            name="pickup_date"
                            value={this.props.values.shipping.pickup_date}
                            label="Felvétel időpontja"
                            showTime={true}
                            disabled={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-3">
                        <DateTimeInput
                            {...this.props.getFieldProps("delivery_date")}
                            name="delivery_date"
                            value={this.props.values.shipping.delivery_date}
                            label="Kézbesítés időpontja"
                            showTime={true}
                            disabled={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <Shipping
                        {...this.props}
                        client={this.props.businessComponent}
                        linkContact={this.props.values.shipping[this.props.componentConfig.idfield] ? false : this.state.autoFill}
                        {...this.props.getFieldProps("shipping")}
                        autoFill={this.props.values.shipping[this.props.componentConfig.idfield] ? false : this.state.autoFill}
                        getFieldProps={this.props.getFieldProps}
                        disabled={this.props.disabled}
                        value={this.props.values.shipping}
                        saveChanges={this.props.setFieldValue}
                    />
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <label className="control-label">Dokumentumok</label>
                        <SelectorGrid
                            {...this.props.getFieldProps("labels")}
                            disabled={false}
                            className={"p-small-table"}
                            view={["filename", "path"]}
                            type={SelectorDocuments}
                            pageSize={0}
                            name={"labels"}
                            data={this.props.values.shipping}
                            componentConfig={this.props.componentConfig}
                            orderBy={{field: "filename", direction: "ASC"}}
                        />
                    </div>
                </div>
                {
                    this.props.values.shipping.serviceprovider_type === "personalpickup"
                    && this.props.values.shipping.cod_amount
                    &&
                    <Fragment>
                        <div className="row form-row">
                            <div className="col-md-3 currency">
                                <TextInput
                                    name="cod_amount"
                                    value={this.props.values.shipping.cod_amount}
                                    formatter={CurrencyFormatter}
                                    label="Utánvét összege"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("cod_amount")}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-md-4">
                                <TextInput
                                    name="cod_title"
                                    value={this.props.values.shipping.cod_title}
                                    label="Gyűjtő"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("cod_title")}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-md-3">
                                <Select
                                    label="Pénztár"
                                    name="moneyrepository"
                                    component="MoneyRepository"
                                    options={this.props.till.moneyrepositories}
                                    objectValue={false}
                                    labelKey="paymentlabel"
                                    valueKey="repository_id"
                                    storeType="local"
                                    {...this.props.getFieldProps("moneyrepository")}
                                    value={this.props.moneyrepository}
                                    disabled={this.props.isLoading || this.props.values.shipping.state + "" === "3" || this.props.values.shipping.state + "" === "0"}
                                    saveChanges={(field, moneyrepository) => this.props.setMoneyRepository(moneyrepository)}
                                />
                            </div>
                        </div>
                    </Fragment>
                }
                {!this.props.values[this.props.componentConfig.idfield] && <Fragment>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <CheckBox value={this.state.autoFill} label="Automatikus adat kitöltés" saveChanges={(field, value) => {
                                this.setState({autoFill: !!value});
                            }} />
                        </div>
                    </div>
                </Fragment>}
            </form>
        );
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(createForm(ShippingServiceForm));
